module.exports = __webpack_public_path__ + "img/search.e181e302.svg";